"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Textarea } from "@/components/ui/textarea"
import { Label } from "@/components/ui/label"
import { usePostHiringCampaignsConfigure } from '../../../../openapi/api/endpoints/default/default';

interface RequirementAnalysisProps {
  onAnalysisComplete: (data: AnalysisResult) => void,
  initialValue:string
}

export type AnalysisResult={
  classification: {
    category: string
    roles: Array<{
      role: string
      description: string
      weight: number
    }>
    why: string
  },
  projectDescription:string
}

export function RequirementAnalysis({ onAnalysisComplete,initialValue }: RequirementAnalysisProps) {
  const [description, setDescription] = useState(initialValue)
  const {mutateAsync:handleRequirements,isPending}=usePostHiringCampaignsConfigure()

  const handleAnalyze = async () => {
    const specs=await handleRequirements({data:{requirements:description}})
    onAnalysisComplete({
      classification:specs.classification,
      projectDescription:description
    })
  }

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="requirement-description">Job Requirement Description</Label>
        <Textarea
          id="requirement-description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Paste the job requirement description here..."
          className="h-32"
          disabled={isPending}
        />
      </div>
      <Button onClick={handleAnalyze}>
        {isPending ? "Analyzing..." : "Analyze Requirement"}
      </Button>
    </div>
  )
}

